// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"1de08d3a","583":"51183892","983":"a7307774"}[chunkId] + ".chunk.js";
};